<template>
  <div class="footer container">
   <div class="footer_container">
    <div class="page_width grid_xs_gap grid_gap_none footer_info">
      <div class="footer_thumb ">
        <div class="footer_logo">
          <img src="../assets/image/logo.png" alt="">
        </div>
     </div>
      <div class="footer_thumb ">
        <div class="thumb_title">Products</div>
        <div class="themb_info"><router-link to="/card-payments">Card Payments</router-link></div>
        <div class="themb_info"><router-link to="/card-payouts">Card Payouts</router-link></div>
        
     </div>
     <div class="footer_thumb ">
        <div class="thumb_title">Use Cases</div>
        <div class="thumb_info_group ">
           <div class="themb_info"><router-link to="/travel-tourism">Travel & Tourism</router-link></div>
          <div class="themb_info"><router-link to="/e-commerce">E-Commerce</router-link></div>
          <div class="themb_info"><router-link to="/e-saas">SaaS</router-link></div>
          <div class="themb_info"><router-link to="/retail">Retail</router-link></div>
        </div>
       <div class="thumb_info_group ">
         <div class="themb_info"><router-link to="/retail">Marketplaces</router-link></div>
         <div class="themb_info"><router-link to="/retail">Educational Platforms</router-link></div>
         <div class="themb_info"><router-link to="/retail">Online Gaming</router-link></div>
      
        
     </div>
        
      </div>

      
      <div class="footer_thumb ">
        <div class="thumb_title">About</div>
       <div class="themb_info"><router-link to="/about-us">Who We Are</router-link></div>
    
      </div>
    
   
     
    </div>
    <div class="page_width mt-50">
       <div class="footer_msg fs-12 color5 fw-300">
        © 2025 Minglepay. All Rights Reserved 
        <div class="mt-20"></div>
       
       </div>
      <div class="footer_copyright flex mt-40">
        <!-- <router-link to="about-us" class="route_tab">About Us</router-link>| -->
        <router-link to="contact-us" class="route_tab">Contact Us</router-link>|
       
        <router-link to="privacy-policy" class="route_tab">Privacy Policy</router-link>|
         <!-- <router-link to="cookiespolicy" class="route_tab">Cookies Policy</router-link>| -->
        <router-link to="terms" class="route_tab">Terms of Use</router-link>
      </div>
    </div>
   </div>
    
    
  </div>
</template>

<script>
export default {
  name:'ASTRfooter',
  data(){
    return{}
    
  },
  methods:{
    toPage(path){
      this.$router.push(path)
    }
  },
  computed:{
    menuList(){return this.$store.state.menuList}
  },
}
</script>

<style lang='scss' scoped>
.footer {

 background: #131625;
  // background-image:url(../../public/bg/footer.png);
  // background-position: center center;
  // background-repeat: no-repeat;
  // background-size: cover;
  
  .footer_container{
    padding-top:20px;
    padding-bottom:30px;
    .footer_logo{
      // clip-path: polygon(0 0, 100% 0, calc(100% - 60px) 100%, 60px 100%);
      // padding: 12px 170px;
      display: block;
      // margin:0 auto;
      >img{
       width: 200px;
      }
    }
    .footer_menu{
      padding:40px 0;
      color:$theme_color1;
      .footer_link{
        padding:10px;
        transition: all 0.35s ease;
        &:hover{
          color:$theme_color3;
        }
      }
    }
    .thumb_info_group{
      display: inline-block;
      width: 50%;
    }
    .footer_info{
      display: grid;
      grid-template-columns: 1fr 1fr 2fr 1fr ;
     
    }
  }
 @media screen and (max-width:767px){
  .footer_info{
    grid-template-columns: 1fr!important;
  }
 }
  .footer_container {
   
    .footer_thumb{
      padding-top:20px;
      text-align: left;
      color:$theme_color1;
      .footer_logo{
        width: 100px;
      }
      .footer_join{
        margin-top:40px;
        font-size: 18px;
        text-align: left;
      }
      .footer_link{
        text-align: left;
        padding:6px; 
        
      }
      .thumb_title{
        font-size: 20px;
        border-bottom: 2px solid #2A2A2A;
        padding-bottom:14px;
        margin-bottom:14px;
      }
      .themb_info{
        line-height: 1.6;
        font-size: 14px;
      
        font-family: PingFang SC, PingFang SC;
        a{
            color:$theme_color5!important;
            font-weight: 300;
            &:hover{
              color:$theme_color1!important;
            }
        }
        .info_fab{
          padding-right:10px;
          
        }
      }
    }
   
  }
  .footer_msg{
    text-align: left;
    line-height: 1.6;
  }
  .footer_copyright{
    // clip-path: polygon(60px 0%, calc(100% - 60px) 0%, 100% 50%, 100% 100%, 0 100%, 0% 50%);
    // padding: 45px 75px;
    font-size: 12px;
    color:$theme_color5;
    font-family: Arial, Helvetica, sans-serif;
    position: relative;
    text-align: left;
    
     .route_tab{
      padding-right:20px;
   
      color:$theme_color5!important;
      font-weight: 300;
      &:hover{
        color:$theme_color1!important;
      }
        
    }
    .route_tab + .route_tab{
      padding-left: 20px;
    }
    // top:60px;
  }
}
</style>